import { render } from "./ModalCloseButton.vue?vue&type=template&id=2a67580d&ts=true"
import script from "./ModalCloseButton.vue?vue&type=script&lang=ts"
export * from "./ModalCloseButton.vue?vue&type=script&lang=ts"

import "./ModalCloseButton.vue?vue&type=style&index=0&id=2a67580d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ModalCloseButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a67580d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a67580d', __exports__)) {
    api.reload('2a67580d', __exports__)
  }
  
  module.hot.accept("./ModalCloseButton.vue?vue&type=template&id=2a67580d&ts=true", () => {
    api.rerender('2a67580d', render)
  })

}


export default __exports__